export default "__VITE_ASSET__DeITZ9ZD__"